'use client';

import { FC } from 'react';

import { Status, TextData } from '@ravago/shared/page-data/models/elements';
import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Chip } from '@ravago/shared/radiance/components/chip/components/Chip/Chip';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useBreakpoint } from '@ravago/shared/radiance/hooks/useBreakpoint/useBreakpoint';
import { useTranslations } from '@ravago/shared/translations/client';

import { getStatusTranslation } from '../../../utils/order/order-helper.utils';

interface Props {
   headerText: TextData;
   id: string | null;
   status?: Status;
   date: string | undefined;
}

export const OrderPageHeader: FC<Props> = ({ headerText, id, status, date }) => {
   const translate = useTranslations();
   const { phone } = useBreakpoint();

   return (
      <Box direction={phone ? 'column' : 'row'} justify="between">
         <Box items="center">
            {id && (
               <Typography variant={headerText.variant} component={headerText.component} align="left" color={headerText.color}>
                  {headerText.value} {id}
               </Typography>
            )}
            {status && (
               <Badge size="regular" variant={status !== 'Invoiced' ? 'info' : 'warning'} weight="bold">
                  {translate(getStatusTranslation(status))}
               </Badge>
            )}
         </Box>
         {date && (
            <Box height="36px">
               <Chip
                  type={
                     <Typography variant="small" component="span" color="strong">
                        {translate('my-orders.estimated-delivery')}
                     </Typography>
                  }
                  label={
                     <Typography variant="small-highlight" component="span" align="left" color="strong">
                        {date}
                     </Typography>
                  }
               />
            </Box>
         )}
      </Box>
   );
};
